import { render, staticRenderFns } from "./BasicCartExpired.vue?vue&type=template&id=36ad53d3&"
import script from "./BasicCartExpired.vue?vue&type=script&lang=js&"
export * from "./BasicCartExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports